import { apiClient } from './apiClient';

export const getReports = async ({ status = '', search = '', page = 0, size = 20 } = {}) => {
  const queryParams = new URLSearchParams();
  if (status) queryParams.append('status', status);
  if (search) queryParams.append('search', search);
  queryParams.append('page', page);
  queryParams.append('size', size);

  return await apiClient(`/admin/reports?${queryParams.toString()}`, {
    method: 'GET',
  }, true);
};

export const getReportById = async (reportId) => {
  if (!reportId) {
    throw new Error('신고 ID가 없습니다.');
  }

  const response = await apiClient(`/admin/reports/${reportId}`, {
    method: 'GET',
  }, true);

  return response.data;
};

export const processReport = async (reportId, payload) => {
  if (!reportId) throw new Error('신고 ID가 없습니다.');

  return await apiClient(`/admin/reports/${reportId}/process`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }, true);
};

export const getReportCategoryLabel = (category) => {
  const labels = {
    STORE_ORDER: '매장 질서 훼손',
    SEAT_USAGE: '좌석/이용 관련',
    FACILITY: '시설/물품',
    RULE_VIOLATION: '규칙 위반',
    OTHER: '기타'
  };
  return labels[category] || category;
};

export const getReportStatusLabel = (status) => {
  const labels = {
    PENDING: '대기중',
    REVIEWED: '검토됨',
    RESOLVED: '처리완료',
    REJECTED: '반려됨'
  };
  return labels[status] || status;
};

export const getReportStatusClass = (status) => {
  const classes = {
    PENDING: 'status-pending',
    REVIEWED: 'status-reviewed',
    RESOLVED: 'status-approved',
    REJECTED: 'status-rejected'
  };
  return classes[status] || '';
};